import DataGrid, {
    Column,
    ColumnChooser,
    ColumnFixing,
    Editing,
    Export,
    FilterRow,
    FilterPanel,
    Grouping,
    GroupPanel,
    HeaderFilter,
    LoadPanel,
    Pager,
    Paging,
    Scrolling,
    SearchPanel,
    Selection,
    Sorting,
    StateStoring,
} from 'devextreme-react/data-grid';
import { getMasterFilterSelectionList } from '../../modules/client';
import React, { Component } from 'react';
import { Button, Popup } from 'semantic-ui-react';

export default class MasterFilterSelectGrid extends Component<
    {
        clientId: Guid,
        filterType: string,
        displayName: string,
        onRemove: (filterType: string) => void,
        onSelectListItem: (filterType: string, component: any) => void,
        initialSelectedValues: any[],
    },
    {
        selectList: any[],
        showLoadPanel: Boolean,
    }
> {
    constructor() {
        super();
        this.dataGrid = null;
        this.state = {
            selectList: [],
            showLoadPanel: false,
        };
    }
    handleSelectionChanged = ({ component }) => {
        this.props.onSelectListItem(this.props.filterType, component);
    };
    componentDidMount(): void {
        this.setState({ showLoadPanel: true }, () => {
            getMasterFilterSelectionList(this.props.clientId, this.props.filterType).then(
                (list) => {
                    this.setState({ selectList: list, showLoadPanel: false });
                    this.dataGrid.instance.selectRows(this.props.initialSelectedValues);
                }
            );
        });
    }
    // TODO- State Storage?
    render() {
        return (
            <div style={{ marginTop: '25px' }}>
                <div style={{ fontWeight: 'bold' }}>
                    <Popup
                        content="Remove this filter type from your selected list"
                        basic
                        trigger={
                            <Button
                                className="ui circular icon button"
                                onClick={() => this.props.onRemove(this.props.filterType)}
                            >
                                <i aria-hidden="true" className="minus icon"></i>
                            </Button>
                        }
                    />
                    {this.props.displayName} Filter
                </div>
                <DataGrid
                    columnHidingEnabled={false}
                    dataSource={this.state.selectList}
                    showBorders
                    style={{ height: '100%', maxHeight: '375px' }}
                    onSelectionChanged={this.handleSelectionChanged}
                    ref={(ref) => (this.dataGrid = ref)}
                    keyExpr="key"
                >
                    <Selection
                        mode="multiple"
                        selectAllMode="allPages"
                        showCheckBoxesMode="onClick"
                    />
                    <LoadPanel enabled={this.state.showLoadPanel} />
                    <FilterRow visible />
                    <HeaderFilter visible />
                    <Scrolling mode="virtual" />
                    <Column
                        allowEditing={false}
                        dataField="Value"
                        dataType="string"
                        headerFilter={{ allowSearch: true }}
                        visible={false}
                    />
                    <Column
                        allowEditing={false}
                        dataField="DisplayField"
                        dataType="string"
                        headerFilter={{ allowSearch: true }}
                    />
                </DataGrid>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/molecules/MasterFilterSelectGrid.jsx